import { C, P0, R, S, abs, arc } from '../../geometry';

export const fan = {
  name: 'Fan',
  colors: ['#8E4EC6', '#E5484D'],
  draw(m, t) {
    let sp = 62 + 3 * S(t * 1.5),
      pose = P0();
    pose.rot = 3 * S(t * 1.1);
    if (m === 'happy') {
      sp = 52 + 26 * abs(S(t * 7));
      pose.rot = 10 * S(t * 7);
    }
    // Thinking: wafts back and forth, opening and closing a little.
    if (m === 'thinking') {
      pose.rot = 15 * S(t * 2.2);
      sp = 60 + 9 * S(t * 4.4);
    }
    if (m === 'talking') {
      sp = 62 + 7 * S(t * 10);
    }
    if (m === 'surprised') {
      sp = 86 + S(t * 30);
    }
    if (m === 'paused') {
      sp = 32;
      pose.rot = -14 + S(t * 0.8);
    }
    const ribs = [-1, -0.55, 0.55, 1].map((k) => {
      const a = (-90 + k * sp) * R;
      return {
        c: 'b',
        pts: [
          [50 + 7 * C(a), 86 + 7 * S(a)],
          [50 + 39 * C(a), 86 + 39 * S(a)],
        ],
      };
    });
    return {
      strokes: [
        { c: 'a', pts: arc(50, 86, 40, -90 - sp, -90 + sp, 11) },
        ...ribs,
        {
          c: 'a',
          pts: [
            [50, 86],
            [50, 94],
          ],
        },
      ],
      eyes: { x: 50, y: 58 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f) {
    const a = f.strokes[0].pts;
    f.strokes[0] = {
      ...f.strokes[0],
      fill: true,
      pts: [[50, 86], ...a, [50, 86]],
      n: 34,
    };
    return f;
  },
};
